module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAA+0lEQVR4AZSRrQrCUBiG9+MWxhhnCIJ3IIgaLCaTyWRaNwgGvQKbwQuw2Ew2MZhMgsUimEUMBi9gPwxBGJvvETf2wzYd38s+3u99vo1zOObPh1NVdQQNwf0Ec57nFRFeEEJOiqK00GdWsJVl2SbP80eAS1mWS2lUAHwDHMC+IAhXgGN4BShSccAfEoBzQGeo7Zv0nQbQGQOoDh1wKCtJksrUzARoAGJxMJooigP0TC6A8N5xnIZhGNM84OG6roZgx7btCw1TJb6AjS8MZrquV0zTXKOPVBzYYWsN4QlSTyhRHwBb71APwa5lWbdEKmTQi9rgP6vQNuSntm8AAAD//5yesZUAAAAGSURBVAMARQ5PhfoFyg4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/arrow.png
// module id = w/Ik
// module chunks = 2